import { Injectable } from '@angular/core';
import { ConfigurationsService } from 'core/services';
import { from, Observable } from 'rxjs';

@Injectable()
export class ResourcesService {
  constructor(public configurationService: ConfigurationsService) {}

  /**
   * Get the values of the dropdowns
   * @param lang
   */
  public getResourceFilters$(lang?: string): Observable<any[]> {
    return this.configurationService.getResourceFilters$({ lang });
  }

  /**
   * Fetch of the resource list
   * @param options
   */
  public fetch(options?: any): Promise<any> {
    return this.configurationService.fetchResources(options);
  }

  /**
   * Fetch of the resource list
   * @param options
   */
  public fetch$(options?: any): Observable<any> {
    return from(this.configurationService.fetchResources(options));
  }
}
